import { Star } from "lucide-react";

interface RatingProps {
  value: number;
  max?: number;
  size?: number;
  className?: string;
}

export function Rating({ value, max = 5, size = 12, className = "" }: RatingProps) {
  const percent = Math.min(Math.max(value / max, 0), 1) * 100;

  const stars = Array.from({ length: max }, (_, i) => (
    <Star key={i} size={size} strokeWidth={0} fill="currentColor" className="shrink-0" />
  ));

  return (
    <div
      role="img"
      aria-label={`Rated ${value} out of ${max}`}
      className={`relative inline-flex ${className}`}
    >
      {/* нижний слой: пустые звёзды */}
      <div className="flex gap-px text-neutral-300">{stars}</div>

      {/* верхний слой: заполненные, обрезаны по ширине */}
      <div
        className="absolute inset-0 flex gap-px overflow-hidden text-neutral-500"
        style={{ width: `${percent}%` }}
      >
        {stars}
      </div>
    </div>
  );
}